import React, { useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import LazyImage from '../../../../Utility/Components/LazyImageComponent';
import Utility from '../../../../Utility/Utility';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';


/* =========================================================
   SEPARATE IMAGE CAROUSEL FOR EACH HOTEL CARD
========================================================= */
const HotelImageCarousel = ({ branchData, deal, hotelImages }) => {

  const [activeImageIndex, setActiveImageIndex] = React.useState(0);

  const nextImage = (e) => {
    e.stopPropagation();

    setActiveImageIndex((prev) =>
      prev === hotelImages.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = (e) => {
    e.stopPropagation();

    setActiveImageIndex((prev) =>
      prev === 0 ? hotelImages.length - 1 : prev - 1
    );
  };

  const selectImage = (e, index) => {
    e.stopPropagation();
    setActiveImageIndex(index);
  };

  React.useEffect(() => {
    if (activeImageIndex >= hotelImages.length) {
      setActiveImageIndex(0);
    }
  }, [hotelImages.length, activeImageIndex]);

  return (
    <div className="hotel-card-redesign-image">

      <div className="hotel-card-image-carousel">
        <div
          className="hotel-card-image-track"
          style={{
            transform: `translateX(-${activeImageIndex * 100}%)`
          }}
        >
          {hotelImages.map((image, imageIndex) => (
            <div
              className="hotel-card-image-slide"
              key={`${branchData.branch_id || branchData.slug || 'hotel'}-${imageIndex}`}
            >
              <LazyImage
                src={image}
                alt={branchData.branch_name || 'Hotel'}
                loaderImage={require('../../../../../public/blankImagehotel.jpg')}
                className="hotel-card-redesign-image-main"
              />
            </div>
          ))}
        </div>
      </div>

      <div className={`hotel-card-offer-label ${deal.className}`}>
        {deal.text}
      </div>

      <label
  className="hotel-card-heart-btn"
  onClick={(e) => e.stopPropagation()}
  aria-label="Favourite"
>
  <input
    type="checkbox"
    className="hotel-card-heart-checkbox"
    onClick={(e) => e.stopPropagation()}
  />

  <i
    className="fa fa-heart-o heart-unchecked"
    aria-hidden="true"
  ></i>

  <i
    className="fa fa-heart heart-checked"
    aria-hidden="true"
  ></i>
</label>

      {hotelImages.length > 1 && (
        <>
          <button
            type="button"
            className="hotel-card-image-arrow hotel-card-image-prev"
            onClick={prevImage}
            aria-label="Previous image"
          >
            <i className="fa fa-chevron-left" aria-hidden="true"></i>
          </button>

          <button
            type="button"
            className="hotel-card-image-arrow hotel-card-image-next"
            onClick={nextImage}
            aria-label="Next image"
          >
            <i className="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </>
      )}

      {hotelImages.length > 1 && (
        <div className="hotel-card-image-dots">
          {hotelImages.map((_, dotIndex) => (
            <button
              type="button"
              key={dotIndex}
              className={activeImageIndex === dotIndex ? 'active' : ''}
              onClick={(e) => selectImage(e, dotIndex)}
              aria-label={`View image ${dotIndex + 1}`}
            ></button>
          ))}
        </div>
      )}

    </div>
  );
};


// Component definition - will be memoized at export
const HotelListItems = (props) => {


  /* =========================================================
     EXISTING IMAGE FUNCTION
  ========================================================= */

  const getBranchImages = (branchData) => {

    const fallback = require('../../../../../public/blankImagehotel.jpg');

    if (!branchData) return [fallback];

    try {

      const allImages =
        Array.isArray(branchData.branch_all_images)
          ? branchData.branch_all_images
          : [];

      const propertyPhotos = allImages.filter(
        img =>
          img.asset_category === "PROPERTY" &&
          img.asset_type === "PHOTO"
      );

      const extractUrls = (source) => {

        if (!source) return [];

        let imageUrl =
          source.image_url !== undefined
            ? source.image_url
            : source;

        if (typeof imageUrl === 'string') {
          try {
            imageUrl = JSON.parse(imageUrl);
          } catch (e) {
            return imageUrl.trim() !== '' ? [imageUrl] : [];
          }
        }

        if (Array.isArray(imageUrl)) {
          return imageUrl
            .map((img) => {
              if (typeof img === 'string') return img;

              return (
                img?.file_url ||
                img?.img_url ||
                img?.image_url ||
                null
              );
            })
            .filter(Boolean);
        }

        if (
          typeof imageUrl === 'object' &&
          imageUrl !== null
        ) {
          const url =
            imageUrl.file_url ||
            imageUrl.img_url ||
            imageUrl.image_url;

          return url ? [url] : [];
        }

        return [];
      };

      let images = [];

      propertyPhotos.forEach((image) => {
        images = [
          ...images,
          ...extractUrls(image)
        ];
      });

      if (
        images.length === 0 &&
        branchData.branch_images
      ) {
        images = extractUrls(branchData.branch_images);
      }

      images = [...new Set(images)].filter(Boolean);

      return images.length > 0 ? images : [fallback];

    } catch (error) {
      console.error('Error parsing branch images:', error);
      return [fallback];
    }

  };


  /* =========================================================
     EXISTING PROPERTY DETAILS FUNCTION
  ========================================================= */

  const hotelRoomTypeDetails =
    useCallback((branchData) => {


      branchData['adults'] =
        props.adult;


      branchData['child'] =
        props.child;


      branchData['start_date'] =
        moment(
          props.start_date
        ).format('YYYY-MM-DD');


      branchData['end_date'] =
        moment(
          props.end_date
        ).format('YYYY-MM-DD');


      const {
        userSearchDataFromReducer
      } = props;


      let tempReducer = {
        ...userSearchDataFromReducer
      };


      tempReducer['selectedRoom'] = {};


      tempReducer['adult'] =
        props.adult;


      tempReducer['children'] =
        props.child;


      tempReducer['start_date'] =
        props.start_date;


      tempReducer['end_date'] =
        props.end_date;


      props.userSearchData(
        tempReducer
      );


      props.selectChooseBranch(
        branchData
      );


      const queryParams =
        Utility.buildUrlParams(
          tempReducer
        );


      props.history.push(
        `/${localStorage.getItem('i18nextLng')}/property-details/${branchData.slug}?${queryParams}`
      );


    }, [
      props.adult,
      props.child,
      props.start_date,
      props.end_date,
      props.userSearchDataFromReducer,
      props.userSearchData,
      props.selectChooseBranch,
      props.history
    ]);


  /* =========================================================
     SAFE HELPER FUNCTIONS FOR NEW DESIGN
  ========================================================= */

  const getReviewScore = (branchData) => {

    if (
      branchData &&
      branchData.customer_rating &&
      branchData.customer_rating.avg != null &&
      Number(branchData.customer_rating.avg) > 0
    ) {

      return parseFloat(
        Math.round(
          Number(branchData.customer_rating.avg) * 10
        ) / 10
      ).toFixed(1);

    }

    return null;

  };


  const getReviewText = (score) => {

    const rating = Number(score);

    if (rating >= 4.5) {

      return 'Excellent';

    }

    if (rating >= 4) {

      return 'Very Good';

    }

    if (rating >= 3) {

      return 'Good';

    }

    if (rating >= 2) {

      return 'Fair';

    }

    return 'Review';

  };


  const getReviewCount = (branchData) => {

    if (
      branchData &&
      branchData.customer_rating &&
      Array.isArray(
        branchData.customer_rating.ratings
      )
    ) {

      return branchData.customer_rating.ratings.length;

    }

    return 0;

  };


  const getNightCount = () => {

    if (
      !props.start_date ||
      !props.end_date
    ) {

      return 0;

    }


    const nights =
      moment(
        props.end_date
      ).diff(
        moment(
          props.start_date
        ),
        'days'
      );


    return nights > 0
      ? nights
      : 0;

  };


  const getDealData = (index) => {

    if (index % 3 === 0) {

      return {
        text: 'Getaway Deal',
        className: 'deal-green'
      };

    }


    if (index % 3 === 1) {

      return {
        text: 'Best Location',
        className: 'deal-blue'
      };

    }


    return {
      text: 'Best Value',
      className: 'deal-purple'
    };

  };


  /* =========================================================
     HOTEL LIST
  ========================================================= */

  if (
    props.searchResult &&
    props.searchResult.length > 0
  ) {


    return props.searchResult.map(
      (branchData, index) => {


        const reviewScore =
          getReviewScore(
            branchData
          );


        const reviewCount =
          getReviewCount(
            branchData
          );


        const deal =
          getDealData(
            index
          );


        const nightCount =
          getNightCount();


        const propertyDetails =
          branchData.branch_full_details || {};


        const amenities =
          Array.isArray(
            branchData.branch_wise_amenity
          )
            ? branchData.branch_wise_amenity
            : [];


        const hotelImages = getBranchImages(branchData);


        return (


          <div
            className='hotelListBox'
            key={branchData.branch_id || branchData.slug || index}
          >


            <div className="hotel-card-redesign">

              {/* IMAGE - separate carousel state for this hotelListBox */}
              <HotelImageCarousel
                branchData={branchData}
                deal={deal}
                hotelImages={hotelImages}
              />


              {/* CONTENT */}
              <div className="hotel-card-redesign-content">


                {/* TOP */}
                <div className="hotel-card-top-row">


                  <div className="hotel-card-main-details">


                    {/* TITLE */}
                    <div className="hotel-card-title-row">

                      <h5>
                        {branchData.branch_name}
                      </h5>

                      {branchData.hasOwnProperty('star_category') &&
                        branchData.star_category &&
                        Number(branchData.star_category) > 0 &&

                        <OverlayTrigger
                          overlay={
                            <Tooltip>
                              {branchData.star_category} Star Property
                            </Tooltip>
                          }
                        >

                          <div className="hotel-card-stars">

                            {[...Array(
                              Math.round(
                                Number(branchData.star_category)
                              )
                            )].map((_, starIndex) => (

                              <i
                                key={starIndex}
                                className="fa fa-star"
                                aria-hidden="true"
                              ></i>

                            ))}

                          </div>

                        </OverlayTrigger>
                      }

                    </div>


                    {/* LOCATION */}
                    <div className="hotel-card-location-row">

                      <div className="hotel-card-main-location">

                        <i
                          className="fa fa-map-marker"
                          aria-hidden="true"
                        ></i>

                        <span>

                          {propertyDetails.address1
                            ? propertyDetails.address1
                            : 'Shyam Nagar'
                          }

                        </span>

                      </div>


                      <span className="hotel-info-dot">
                        •
                      </span>

                      <span className="hotel-distance-text">
                        1.8 km from centre
                      </span>

                      <span className="hotel-info-dot">
                        •
                      </span>

                    </div>


                    {/* SECOND ROW */}
                    <div className="hotel-card-secondary-location">

                      <span>

                        <i
                          className="fa fa-train"
                          aria-hidden="true"
                        ></i>

                        Metro access

                      </span>

                      <span className="hotel-info-dot">
                        •
                      </span>

                      <span>

                        <i
                          className="fa fa-umbrella"
                          aria-hidden="true"
                        ></i>

                        250 m from beach

                      </span>

                    </div>

                  </div>


                  {/* REVIEW */}
                  <div className="hotel-card-review">

                    <div className="hotel-card-review-text">

                      <strong>
                        {reviewScore
                          ? getReviewText(reviewScore)
                          : 'Excellent'
                        }
                      </strong>

                      <small>

                        {reviewCount > 0
                          ? `${reviewCount.toLocaleString()} reviews`
                          : '1,260 reviews'
                        }

                      </small>

                    </div>


                    <button
                      type="button"
                      className="hotel-card-score"
                      onClick={(e) => {

                        e.stopPropagation();

                        if (
                          branchData.customer_rating &&
                          branchData.customer_rating.ratings &&
                          branchData.customer_rating.ratings.length > 0
                        ) {

                          props.showReviewModalFn(
                            branchData.customer_rating.ratings
                          );

                        }

                      }}
                    >

                      {reviewScore || '5.0'}

                    </button>

                  </div>

                </div>


                {/* MIDDLE / BOTTOM */}
                <div className="hotel-card-middle-bottom">


                  <div className="hotel-card-left-bottom">


                    {/* ROOM DETAILS */}
                    <div className="hotel-card-room-info">

                      <strong>
                        {propertyDetails.property_type || 'Luxury Hotel'}
                      </strong>

                      <span className="hotel-card-divider">
                        |
                      </span>

                      <span>
                        Sea View Room
                      </span>

                      <span className="hotel-card-info-bullet">
                        •
                      </span>

                      <span>
                        King Bed
                      </span>

                      <span className="hotel-card-info-bullet">
                        •
                      </span>

                      <span>
                        40 m²
                      </span>

                    </div>


                    {/* FEATURE PILLS */}
                    <div className="hotel-card-redesign-amenities">

                      <span className="hotel-card-amenity-pill">

                        <i
                          className="fa fa-check"
                          aria-hidden="true"
                        ></i>

                        <span>
                          Free cancellation
                        </span>

                      </span>


                      <span className="hotel-card-amenity-pill">

                        <i
                          className="fa fa-pagelines"
                          aria-hidden="true"
                        ></i>

                        <span>
                          Spa access
                        </span>

                      </span>


                      <span className="hotel-card-amenity-pill">

                        <i
                          className="fa fa-cutlery"
                          aria-hidden="true"
                        ></i>

                        <span>
                          Breakfast included
                        </span>

                      </span>

                    </div>

                  </div>


                  {/* PRICE AREA */}
                  <div className="hotel-card-price-section">

                    <div className="hotel-card-discount">
                      10% off
                    </div>


                    <div className="hotel-card-price-line">

                      <span className="hotel-old-price">

                        {Utility.getCurrencySymbol(branchData.currency)}

                        {Math.round(
                          Number(branchData.total_room_rate) * 1.1
                        )}

                      </span>


                      <span className="hotel-current-price">

                        {Utility.getCurrencySymbol(branchData.currency)}

                        <strong>
                          {branchData.total_room_rate}
                        </strong>

                      </span>

                    </div>


                    <div className="hotel-card-stay-info">

                      {nightCount > 0
                        ? nightCount
                        : 5
                      } nights,

                      {' '}

                      {props.adult
                        ? props.adult
                        : 2
                      } adults

                    </div>

                  </div>

                </div>


                {/* CLICK AREA */}
                <button
                  type="button"
                  className="hotel-card-click-area"
                  aria-label="View rooms"
                  onClick={() => {
                    hotelRoomTypeDetails(branchData);
                  }}
                ></button>

              </div>

            </div>


          </div>


        );


      }
    );


  } else {


    if (props.apiCallFinish) {

      return (

        <div className='norecordfound'>

          No Data Found

        </div>

      );

    }


  }


};


// Create a pure component with custom comparison to prevent unnecessary re-renders
// Only re-render when critical props change
export default withRouter(

  React.memo(

    HotelListItems,

    (prevProps, nextProps) => {


      if (
        !prevProps.searchResult &&
        !nextProps.searchResult
      ) {

        return true;

      }


      if (
        !prevProps.searchResult ||
        !nextProps.searchResult
      ) {

        return false;

      }


      if (
        prevProps.searchResult.length !==
        nextProps.searchResult.length
      ) {

        return false;

      }


      const startDateEqual =
        prevProps.start_date?.toString() ===
        nextProps.start_date?.toString();


      const endDateEqual =
        prevProps.end_date?.toString() ===
        nextProps.end_date?.toString();


      const adultsEqual =
        prevProps.adult ===
        nextProps.adult;


      const childrenEqual =
        prevProps.child ===
        nextProps.child;


      let searchResultEqual = true;


      if (
        prevProps.searchResult.length ===
        nextProps.searchResult.length
      ) {


        for (
          let i = 0;
          i < prevProps.searchResult.length;
          i++
        ) {


          if (
            prevProps.searchResult[i].branch_id !==
            nextProps.searchResult[i].branch_id
          ) {

            searchResultEqual = false;

            break;

          }


        }


      } else {

        searchResultEqual = false;

      }


      return (
        adultsEqual &&
        childrenEqual &&
        startDateEqual &&
        endDateEqual &&
        searchResultEqual
      );


    }

  )

);